import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
export const index = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/countries/{country}/states',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
index.url = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { country: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { country: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            country: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        country: typeof args.country === 'object'
        ? args.country.id
        : args.country,
    }

    return index.definition.url
            .replace('{country}', parsedArgs.country.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
index.get = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
index.head = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
const indexForm = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
indexForm.get = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\StateController::index
* @see app/Http/Controllers/Admin/Locations/StateController.php:93
* @route '/dashboard/locations/countries/{country}/states'
*/
indexForm.head = (args: { country: string | number | { id: string | number } } | [country: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const states = {
    index: Object.assign(index, index),
}

export default states